import React, { forwardRef, useState, useEffect } from "react";
import { Tag } from "./Tag";
import { ROUTES } from "../utils/Routes";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";

const Tags = forwardRef(function Tags(props, ref) {
  const {
    edit = false,
    value = "",
    readvalue = false,
    width = 400,
    height = 48,
    items = [],
    onFocus = () => { },
    onBlur = () => { },
    onClick = () => { },
    onChange = () => { },
    callback = () => { },
    goto = () => { }
  } = props;




  // Parse incoming value string into array of selected values
  const [tags, setTags] = useState(
    value ? value.split("|").filter(Boolean) : []
  );


  


  useEffect(() => {

    if (!value) {
      return;
    }
    setTags(
      value ? value.split("|").filter(Boolean) : []
    );
  }, [value])


  const [currentIdx, setCurrentIdx] = useState((readvalue) ? -1 : 0);

  const toggleTag = (idx) => {
    const val = items[idx].value;

    const updated = tags.includes(val)
      ? tags.filter((t) => t !== val)
      : [...tags, val];


    setTags(updated);
    onChange(tagsToString(updated))
  };

  const tagsToString = (arr) => arr.join("|");

  useEffect(() => {
    if (!edit || readvalue) return;
    window.bm_state.value = ROUTES.HELPERS.TAGS;

    const actions = [
      { key: KBD.ARROW_DOWN, action: () => { callback(tagsToString(tags), "next") } },
      { key: KBD.ARROW_UP, action: () => { callback(tagsToString(tags), "prev") } },
      {
        key: KBD.ARROW_RIGHT,
        action: () => {
          if (currentIdx === items.length - 1) {
            setCurrentIdx(0);
          } else {
            setCurrentIdx((i) => i + 1);
          }
        },
      },
      {
        key: KBD.ARROW_LEFT,
        action: () => {
          currentIdx === 0
            ? setCurrentIdx(items.length - 1)
            : setCurrentIdx((i) => i - 1);
        },
      },
      { key: KBD.TAB, action: () => { callback(tagsToString(tags), "next") } },
      { key: KBD.SHIFT_TAB, action: () => { callback(tagsToString(tags), "prev") } },
      { key: KBD.ENTER, action: () => toggleTag(currentIdx) },
      { key: KBD.SPACE, action: () => toggleTag(currentIdx) },
      { key: KBD.ALT_C, action: () => goto("columns") },
      { key: KBD.PAGE_DOWN, action: () => goto("save") },
      { key: KBD.ESCAPE, action: () => goto("escape") },
    ];

    return listen(ROUTES.HELPERS.TAGS, actions, () => { }, []);
  }, [edit, currentIdx, tags]);

  const focus = (edit) ? " ui-outline" : " no-focus"
  return (
    <div
      ref={ref}
      tabIndex={0}
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={(e) => {
        e.currentTarget.focus();
        onClick(e);
      }}
      className={(readvalue) ? "ui-tags no-focus" + focus : "ui-tags" + focus}
      style={{ maxWidth: `${width}px`, height: `${height}px` }}
    >
      {items.map((item, idx) => (
        <Tag
          edit={edit}
          key={idx}
          label={item.label}
          active={tags.includes(item.value)}
          current={idx === currentIdx}
          onClick={() => {
            if (readvalue) {
              return;
            }
            setCurrentIdx(idx);
            toggleTag(idx);
          }}
        />
      ))}
    </div>
  );
});

export default Tags;
